@switch (pageLayout()) {
  @case ('main') {
    <main-layout></main-layout>
  }

  @case ('blank') {
    <blank-layout></blank-layout>
  }
}

<palantir-toast></palantir-toast>

<app-debug-indicator></app-debug-indicator>
